module.exports = __webpack_public_path__ + "img/lootbox.d54d1fdd.svg";